/**
 * Main Application
 * Controls the application, all modules are initialised here
 */

// Inline Dependencies
import $ from 'jquery';
require('../libs/jquery.easing-1.3.2.min.js');
require('./plugins/pointer-events-polyfill');
require('./plugins/tooltipster.bundle.min');

// Utilities
import attachFastClick from 'fastclick';
import { iOSDetect, debounce } from './modules/utils';

// Require modules here:
import forms from './modules/forms';
import layout from './modules/layout';
import navigation from './modules/navigation';
import sitesNavigation from './modules/sitesNavigation';
import slick from './modules/slick';
import modal from './modules/modal';
import searchBar from './modules/searchBar';
import videoBox, { positionContent } from './modules/videoBox';
import matchHeight from './modules/matchHeight';
import faqs from './modules/faqs';
import accordion from './modules/accordion';
import expandableCards, {
	resize as expandableCardsResize,
} from './modules/expandableCards';
import erpCalculator from './modules/erpCalculator';
import tabs from './modules/tabs';
import maps from './modules/maps';
import filters from './modules/filters';
import tableWrapper, {
	resize as tableWrapperResize,
} from './modules/tableWrapper';
import scrollToAnchors, {
	resize as scrollToAnchorsResize,
} from './modules/scrollToAnchors';
import stickyNav, { resize as stickyNavresize } from './modules/stickyNav';
import iframeResizer from './modules/iframeResizer';
import parallax from './modules/parallax';
import productSelector from './modules/productSelector';
import productSelectorMessage from './modules/productSelectorMessage';
import pdf from './modules/pdf';
import requestCallBack from './modules/requestCallBack';
import commissioningForm from './modules/commissioningForm';
import areaMap from './modules/areaMap';
import carousel from './modules/carousel';
import toggleContent from './modules/toggleContent';

// Launch our App
(function(window, document) {
	// Initialise fastclick
	attachFastClick(document.body);

	// Body is not loading anymore
	$('body').removeClass('is-loading');

	// iOS detection classes
	iOSDetect();

	// Modules
	forms();
	layout();
	navigation();
	sitesNavigation();
	slick();
	modal();
	searchBar();
	videoBox();
	matchHeight();
	faqs();
	accordion();
	expandableCards();
	erpCalculator();
	tabs();
	maps();
	scrollToAnchors();
	stickyNav();
	filters();
	tableWrapper();
	iframeResizer();
	parallax();
	productSelector();
	productSelectorMessage();
	pdf();
	requestCallBack();
	areaMap();
	carousel();
	toggleContent();

	// DO NOT WANT THIS RUNNING ON EVERY PAGE
	if ($('#commissioningForm').length > 0) {
		commissioningForm();
	}

	// Stop resize from firing constantly
	const fireAfterResize = debounce(function() {
		positionContent();
		// expandableCardsResize();
		tableWrapperResize();
		scrollToAnchorsResize();
		stickyNavresize();
	}, 100);

	$(window).on('resize', function() {
		fireAfterResize();
		expandableCardsResize();
	});
}(window, document));
